package com.mxpainting.components.sections

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import com.mxpainting.Language
import com.mxpainting.LanguageState
import com.mxpainting.Strings
import com.mxpainting.rememberLanguage
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.classNames
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.A
import org.jetbrains.compose.web.dom.Button
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.H2
import org.jetbrains.compose.web.dom.I
import org.jetbrains.compose.web.dom.Img
import org.jetbrains.compose.web.dom.Nav
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

@Composable
fun Nav() {
    val language by rememberLanguage()

    Nav(Modifier.fillMaxWidth().classNames("navbar", "navbar-expand-lg", "bg-white", "navbar-light", "sticky-top", "p-0", "px-4", "px-lg-5").toAttrs()) {
        A(href = "/", attrs = Modifier.classNames("navbar-brand", "d-flex", "align-items-center").toAttrs()) {
            H2(Modifier.classNames("m-0", "text-primary").toAttrs()) {
                Img(src = "/img/mx-painting.png", alt = "MX Painting Logo", attrs = Modifier.classNames("me-2").styleModifier { property("width", "50px") }.toAttrs())
                Text("MX Painting")
            }
        }

        // Mobile Language Toggle
        Div(Modifier
            .classNames("ms-auto", "me-3", "d-flex", "align-items-center", "d-lg-none")
            .onClick {
                LanguageState.setLanguage(if (language == Language.ENGLISH) Language.SPANISH else Language.ENGLISH)
            }
            .toAttrs()
        ) {
            Img(
                src = if (language == Language.ENGLISH) "/img/flag_mx.png" else "/img/flag_ca.png",
                alt = if (language == Language.ENGLISH) "Switch to Spanish" else "Switch to English",
                attrs = Modifier.width(32.px).height(32.px).borderRadius(50.percent).toAttrs()
            )
        }

        Button(attrs = Modifier.classNames("navbar-toggler").toAttrs {
            attr("data-bs-toggle", "collapse")
            attr("data-bs-target", "#navbarCollapse")
        }) {
            Span(Modifier.classNames("navbar-toggler-icon").toAttrs()) {}
        }

        Div(Modifier.classNames("collapse", "navbar-collapse").id("navbarCollapse").toAttrs()) {
            Div(Modifier.classNames("navbar-nav", "ms-auto", "py-4", "py-lg-0").toAttrs()) {
                A(href = "/", attrs = Modifier.classNames("nav-item", "nav-link", "active").toAttrs()) {
                    Text(Strings.home[language].orEmpty())
                }
                A(href = "/services", attrs = Modifier.classNames("nav-item", "nav-link").toAttrs()) {
                    Text(Strings.services[language].orEmpty())
                }
                A(href = "/contact", attrs = Modifier.classNames("nav-item", "nav-link").toAttrs()) {
                    Text(Strings.contact[language].orEmpty())
                }
            }
            A(href = "/contact", attrs = Modifier.classNames("btn", "btn-primary", "py-2", "px-lg-5", "d-none", "d-lg-block").toAttrs()) {
                Text(Strings.navGetAQuote[language].orEmpty())
                I(Modifier.classNames("fa", "fa-arrow-right", "ms-3").toAttrs()) {}
            }
        }
    }
}
